import React, { Component } from "react";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { CRUDFunction } from "../../../../reduxCURD/container";
import { curdActions } from "../../../../reduxCURD/actions";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import { EngineHoursSchema, getSchemaList, getTemplate, TableHeaders } from "./Schema";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";

class OEMSingleReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      OEM: null,
      Schema: [],
    };
  }

  componentDidMount() {
    const { testCode } = this.props;
    if (testCode) this.props.getApplicationlookupss(`/MaintenanceOEM/${testCode}`);
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.applicationlookupss != prevProps.applicationlookupss &&
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS"
    ) {
      if (this.props.applicationlookupss.length > 0) {
        // if there is no OEM in database then app won't crash
        let schemaData = getSchemaList(this.props.applicationlookupss[0]);
        this.setState({ OEM: this.props.applicationlookupss[0], Schema: schemaData });
      }
    }
  }

  render() {
    const { props } = this;
    const { reportData, isPreview } = props;
    if (!reportData) return null;
    let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
    // let removeDuplicates = ReportGroupingUtils.RemoveDuplicateTestCodesFromGroupedReport(reportsByDateAndUser);
    let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(reportsByDateAndUser);

    return (
      <React.Fragment>
        {decodedReports.map((report, i) => {
          return (
            <div key={i}>
              <ReportView key={i} data={report} {...props} Schema={this.state.Schema} />
            </div>
          );
        })}
      </React.Fragment>
    );
  }
}
const ReportView = (props) => {
  const { data, title, Schema } = props;
  const { decodedData, fraHeaderInfo } = data;
  return decodedData.map((singleReport, index) => (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }} key={index}>
      <ReportTitleSection title={title} fontSizeOverride={"35px"} />
      <ReportFraInfoSectionContainer {...props} />
      <span className="spacer"></span>
      {singleReport.summary.engHour && (
        <table className="table-bordered">
          <ReportTableSectionRenderer rowsData={singleReport.summary} section={EngineHoursSchema} />
        </table>
      )}
      <table className="table-bordered">
        {TableHeaders.map((e, i) => (
          <ReportTableSectionRenderer section={e} rowsData={{}} key={`header ${i}`} />
        ))}
        {Schema.map((ele, index) => {
          return <ReportTableSectionRenderer section={getTemplate(ele.name, ele.id)} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
    </div>
  ));
};

const getApplicationlookupss = curdActions.getApplicationlookupss;

let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    getApplicationlookupss: getApplicationlookupss,
  },
};

let variables = {
  applicationlookupsReducer: {
    applicationlookupss: [],
  },
};
const OEMSingleReportContainer = CRUDFunction(
  OEMSingleReport,
  "OEMSIngleReportData",
  actionOptions,
  variables,
  ["applicationlookupsReducer"],
  "oem",
);

export default OEMSingleReportContainer;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/OEMSingleReport/OEMSingleReport.jsx